import styled from '@emotion/styled'

import { Link, palette, spacing, Text, typography } from 'main/ui'

export const Clear = styled(Link)`
  margin-right: ${spacing.majorScale(4)}px;
  color: ${palette.slate};
`

export const Apply = styled(Link)`
  color: ${palette.skyBlue2};
`

export const Label = styled(Text)`
  font-weight: ${typography.fontWeight.bold};
`

export const FormSubmitContainer = styled.div`
  align-self: flex-end;
  margin-top: ${spacing.majorScale(2)}px;
`
